var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBags(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.547,
    height: 69.877,
    viewBox: "0 0 57.547 69.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "S\\xE4ckar",
    transform: "translate(0.955 0.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24324",
    "data-name": "Path 24324",
    d: "M-65.43,14.745l31.365-9.861,22.811,10.1L-38.7,24.844Z",
    transform: "translate(66.465 3.254)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24325",
    "data-name": "Path 24325",
    d: "M-65.43,12.585V48.82a3.312,3.312,0,0,0,1.953,3.019l23.123,10.416a3.314,3.314,0,0,0,2.62.044l24.653-10.133a3.31,3.31,0,0,0,2.052-3.083l-.223-36.26",
    transform: "translate(66.465 5.414)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1049",
    "data-name": "Line 1049",
    y1: 39.824,
    transform: "translate(27.765 28.103)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1050",
    "data-name": "Line 1050",
    y2: 18.297,
    transform: "translate(32.401 8.138)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24326",
    "data-name": "Path 24326",
    d: "M-24.243,14.1l-1.186-6.292A1.608,1.608,0,0,1-23.849,5.9h0a1.608,1.608,0,0,1,1.6,1.739l-.512,6.341",
    transform: "translate(77.673 3.54)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24327",
    "data-name": "Path 24327",
    d: "M-41.317,6.725-42.5.433a1.607,1.607,0,0,1,1.58-1.905h0a1.609,1.609,0,0,1,1.6,1.738l-.513,6.341",
    transform: "translate(72.886 1.472)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24328",
    "data-name": "Path 24328",
    d: "M-65.025,14.2-66.21,7.9A1.608,1.608,0,0,1-64.63,6h0a1.608,1.608,0,0,1,1.6,1.738l-.513,6.342",
    transform: "translate(66.238 3.566)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24329",
    "data-name": "Path 24329",
    d: "M-45.307,21.757l-1.184-6.292a1.607,1.607,0,0,1,1.58-1.905h0a1.608,1.608,0,0,1,1.6,1.737l-.513,6.341",
    transform: "translate(71.767 5.687)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1051",
    "data-name": "Line 1051",
    x1: 8.376,
    y2: 2.792,
    transform: "translate(47.014 41.404)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1052",
    "data-name": "Line 1052",
    x1: 11.109,
    y2: 3.861,
    transform: "translate(44.222 46.394)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1053",
    "data-name": "Line 1053",
    x1: 14.435,
    y2: 5.109,
    transform: "translate(40.895 51.147)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBags);
export default __webpack_public_path__ + "static/media/Icon_bags.f00d1a4c85660d99700edfeb757ec5c7.svg";
export { ForwardRef as ReactComponent };